export default value => {
    if (!value) return '';

    const str = String(value);

    if (str.length != 10) return str;


    const d1 = str.slice(0, 3);
    const d2 = str.slice(3, 6);
    const d3 = str.slice(6, 8);
    const d4 = str.slice(8, 10);

    return `+7 (${d1}) ${d2}-${d3}-${d4}`;
};
